import { defineMessages } from 'react-intl'

export default defineMessages({
  submit: {
    id: 'aboutyoupage.form.submit',
    defaultMessage: 'Submit',
  },
  continue: {
    id: 'aboutyoupage.form.continue',
    defaultMessage: 'Continue',
  },
  termsAndConditionsRequired: {
    id: 'aboutyoupage.form.termsandconditionsrequired',
    defaultMessage: 'You must read and accept the terms and conditions',
  },
  bannerHeading: {
    id: 'aboutyoupage.form.bannerheading',
    defaultMessage: 'Thanks for joining us!',
  },
  bannerBody: {
    id: 'aboutyoupage.form.bannerbody',
    defaultMessage:
      "Next, let's learn about you. Your information will help us find the best possible care.",
  },
  zipCodeError: {
    id: 'aboutyoupage.form.zipcodeerror',
    defaultMessage: 'The ZIP code is invalid',
  },
})
